import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { distinctUntilChanged, filter, first, shareReplay, switchMap } from 'rxjs';

import { AccessTokenProvider } from '@mobi/rwc-utils-azure-ng-jslib';
import { Logger } from '@mobi/rwc-utils-common-ng-jslib';

import { CIP_CONFIG_ID } from './cip-auth.config';

export class CipAccessTokenService implements AccessTokenProvider {
    #oauthService = inject(OidcSecurityService);
    #logger = inject(Logger).createCustomLogger('OAUTH');

    // isAuthenticated$ fired also after each token refresh
    readonly accessTokenChanged$ = this.#oauthService.isAuthenticated$
        .pipe(switchMap(() => this.#oauthService.getAccessToken(CIP_CONFIG_ID)))
        .pipe(filter(Boolean), distinctUntilChanged(), shareReplay(1));

    readonly accessTokenOnce$ = this.accessTokenChanged$.pipe(first());

    constructor() {
        this.#logger.info('Use CIP authentication.');
    }
}
